import React from 'react';
import { Form, Input, Icon, Header } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const SocialProfiles = ({ socialProfiles = {}, onChange, t, errors = {} }) => {
  const handleChange = (platform, value) => {
    onChange({
      ...socialProfiles,
      [platform]: value,
    });
  };

  const validateUrl = (platform, url) => {
    if (!url) return true;

    const patterns = {
      goodreads: /^https?:\/\/(www\.)?goodreads\.com\/user\/show\//,
      tome: /^https?:\/\/(www\.)?tome\.app\//,
      instagram: /^https?:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/,
      tiktok: /^https?:\/\/(www\.)?tiktok\.com\/@[a-zA-Z0-9_.]+\/?$/,
    };

    return patterns[platform]?.test(url) ?? false;
  };

  return (
    <div>
      <Header as="h3" icon>
        <Header.Subheader>{t('SocialProfilesDescription')}</Header.Subheader>
      </Header>

      <Form.Field>
        <label>
          <Icon name="book" /> Goodreads
        </label>
        <Input
          placeholder="https://www.goodreads.com/user/show/12345-your-name"
          value={socialProfiles.goodreads || ''}
          onChange={e => handleChange('goodreads', e.target.value)}
          error={errors.goodreads}
        />
        {errors.goodreads && (
          <div className="ui pointing red basic label">
            {t('ValidGoodreadsUrl')}
          </div>
        )}
      </Form.Field>

      {/* <Form.Field>
        <label>
          <Icon name="book" /> Tome
        </label>
        <Input
          placeholder="https://tome.app/your-profile"
          value={socialProfiles.tome || ''}
          onChange={e => handleChange('tome', e.target.value)}
          error={errors.tome}
        />
        {errors.tome && (
          <div className="ui pointing red basic label">{t('ValidTomeUrl')}</div>
        )}
      </Form.Field> */}

      <Form.Field>
        <label>
          <Icon name="instagram" /> Instagram
        </label>
        <Input
          placeholder="https://www.instagram.com/your-username"
          value={socialProfiles.instagram || ''}
          onChange={e => handleChange('instagram', e.target.value)}
          error={errors.instagram}
        />
        {errors.instagram && (
          <div className="ui pointing red basic label">
            {t('ValidInstagramUrl')}
          </div>
        )}
      </Form.Field>

      <Form.Field>
        <label>
          <Icon name="video" /> TikTok
        </label>
        <Input
          placeholder="https://www.tiktok.com/@your-username"
          value={socialProfiles.tiktok || ''}
          onChange={e => handleChange('tiktok', e.target.value)}
          error={errors.tiktok}
        />
        {errors.tiktok && (
          <div className="ui pointing red basic label">
            {t('ValidTikTokUrl')}
          </div>
        )}
      </Form.Field>
    </div>
  );
};

export default withTranslation()(SocialProfiles);
